import config from './config';

export function createKahsierFrame({
	amount,
	description,
	orderHash,
	orderId,
	currency = 'EGP',
	merchantId,
	companyName
}: any) {
	removeKashierFrame();
	let script = document.createElement('script');
	script.src = config.kashierIframeURL;
	// script.src = 'https://iframe.payformance.io/js/kashier-checkout.js';
	script.setAttribute('id', 'kashier-iFrame');
	script.setAttribute('data-amount', amount);
	script.setAttribute('data-hash', orderHash);
	script.setAttribute('data-currency', currency);
	script.setAttribute('data-mode', config.paymentMode);
	script.setAttribute('data-orderId', orderId);
	script.setAttribute('data-merchantId', merchantId);
	script.setAttribute('data-brandColor', 'rgb(8, 204, 148)');
	script.setAttribute('data-merchantRedirect', config.paymentRedirectUrl);
	script.setAttribute('data-allowedMethods', 'card');
	script.setAttribute('data-serverWebhook', encodeURIComponent(config.paymentWebhookUrl));
	script.setAttribute('data-metaData', JSON.stringify({ company: companyName }));
	script.setAttribute('data-store', 'Tech Arena for IT');
	script.setAttribute('data-type', 'external');
	script.setAttribute('data-display', 'en');
	script.type = 'text/javascript';
	document.body.appendChild(script);
	return new Promise<void>((resolve, reject) => {
		script.onload = e => resolve();
		script.onerror = e => reject(e);
	});
}
//localhost:3000/dashboard/subscription?paymentStatus=SUCCESS&cardDataToken=&maskedCard=511111******1118&merchantOrderId=5fe33e9d74689e3ddc06cd20&orderId=a412ea56-6d97-47e3-864c-9f3c28f44bbc&cardBrand=&orderReference=TEST-ORD-193270704&transactionId=TX-79786107&amount=100&currency=EGP&signature=6bb736836406aed3840ac3b619d94d8adfdf11ba6b2de2bb0b5b310b7901d316&mode=test
export function removeKashierFrame() {
	let frame = document.getElementById('kashier-iFrame');
	let btns = document.getElementsByClassName('el-kashier-div-button');
	while (frame) {
		frame.parentNode!.removeChild(frame);
		frame = document.getElementById('kashier-iFrame');
	}
	for (let btn of btns) {
		btn.nextElementSibling!.remove();
		btn.remove();
	}
}
